import { getFormattedDate } from '../../helper';

const CreatedOnCell = ({ date, dateFormat }: { date: any; dateFormat: string }) => {
  if (date) {
    const formattedTime = getFormattedDate(date, dateFormat);
    return <div className='fs-6'>{formattedTime}</div>;
  } else {
    return <div className='fs-6'>{'N/A'}</div>;
  }
};

export const TravelDateCell = ({ fromDate, toDate, dateFormat, year }: { fromDate: any; toDate: any, dateFormat: string, year:boolean }) => {
  if (fromDate && toDate) {
    const formattedFromDate = getFormattedDate(fromDate, dateFormat);
    const formattedToDate = getFormattedDate(toDate, dateFormat);
    const Toyear = getFormattedDate(toDate, 'YYYY');
    const formattedTime = year ? `${formattedFromDate} - ${formattedToDate}, ${Toyear}` : `${formattedFromDate} - ${formattedToDate}`;
    return <div className='fs-6'>{formattedTime}</div>;
  } else {
    return <div className='fs-6'>{'N/A'}</div>;
  }
};

export default CreatedOnCell;
